import { Modal,Box,Button } from "@mui/material"
import { useSelector,useDispatch } from "react-redux"
import { TranslateText } from "../utils/googletranslator"
import { updateConfirmationPop,updateSelectedCategory } from "../redux/products"
import CustomAxios from "../utils/CustomAxios"
import { updateConfirmationMessage,updateProductSubCategory,updateCategoryForm,updateConfirmationOperation,updateProductCategory } from "../redux/products"
const Confirmation=({action,message,operation})=>{
const confirmationPop=useSelector(state=>state.product.confirmationPop)
const confirmationMessage=useSelector(state=>state.product.confirmationMessage)
const confirmationOperation=useSelector(state=>state.product.confirmationOperation)
const formModal=useSelector(state=>state.product.formModal)
const selectedcategory=useSelector(state=>state.product.selectedCategory)
let dispatch=useDispatch()

const deleteSubAction=()=>{
    // console.log(selectedcategory)
    if(formModal=='subcategory') {
    CustomAxios.delete(`create_subcategories/${selectedcategory.id}`).then(res=>{
        // console.log("????????????",res)
        if(res.data.message=='Successfully deleted'){
            dispatch(updateProductSubCategory(res.data.subcategories?res.data.subcategories:[]))
            dispatch(updateCategoryForm(false))
            dispatch(updateSelectedCategory({}))
            dispatch(updateConfirmationPop(false))
            // handleClose()
        }
        else{
            dispatch(updateConfirmationPop(true))
            dispatch(updateConfirmationOperation ("error"))
            dispatch(updateConfirmationMessage("Sorry, Please update category on previous products") )
        }
    }).catch(err=>{
        dispatch(updateConfirmationPop(true))
        dispatch(updateConfirmationOperation ("error"))
            dispatch(updateConfirmationMessage("Sorry, Please update category on previous products") )
    })
}
else if(formModal=='category') {
    CustomAxios.delete(`create_categories/${selectedcategory.id}`).then(res=>{
        // console.log("????????????",res)
        if(res.data.message=='Successfully deleted'){
            dispatch(updateProductCategory(res.data.categories?res.data.categories:[]))
            dispatch(updateSelectedCategory({}))
            dispatch(updateCategoryForm(false))
            dispatch(updateConfirmationPop(false))
        }
        else{
            dispatch(updateConfirmationPop(true))
            dispatch(updateConfirmationOperation ("error"))
            dispatch(updateConfirmationMessage("Sorry, Please update category on previous products") )
        }
    }).catch(err=>{
        dispatch(updateConfirmationPop(true))
        dispatch(updateConfirmationOperation ("error"))
        dispatch(updateConfirmationMessage("Sorry, Please update category on previous products") )
    })

}
}


return<Modal
open={confirmationPop}
// onClose={handleClose}
aria-labelledby="child-modal-title"
aria-describedby="child-modal-description"
sx={{zIndex:"21 !important"}}
>
<Box sx={{ width: "300px", background: "#fff", left: "50%", top: "50%", position: "absolute", transform: 'translate(-50%, -50%)', padding: "24px", border: "none" ,overflowY:"auto",height:{xs:"95%",sm:"max-content"}}}>
<Box sx={{display:"flex",flexDirection:"column",gap:"5px", }}>
    <TranslateText>
        {confirmationMessage}
        
    </TranslateText>
    <Box sx={{alignSelf:"center",display:"flex",gap:"5px"}}>
        {confirmationOperation=='confirmation'&&<Button variant="contained" sx={{maxWidth:"100px",alignSelf:"end",textTransform:"none",height:"48px" }} onClick={deleteSubAction}>Delete</Button>}
        
        <Button variant="outlined" sx={{maxWidth:"100px",alignSelf:"end",textTransform:"none",height:"48px" }} onClick={()=>{dispatch(updateConfirmationPop(false));}}>Cancel</Button>
        
        </Box>
    </Box>
    
</Box></Modal>

}

export default Confirmation